import { r as s } from "../util-b2b0dc25.js";
import { openBlock as a, createElementBlock as i } from "vue";
import { _ as l } from "../_plugin-vue_export-helper-dad06003.js";
const c = /<span(.*?)<\/span>/g, p = {
  name: "rHighlightText",
  props: {
    /**
     * 高亮配置，{key, color}[]
     */
    configs: {
      type: Array,
      default: () => []
    },
    /**
     * 开启区分大小写
     */
    openCaseMode: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    textarr() {
      let t = this.$slots.default().filter((e) => e.shapeFlag === 8).map((e) => e.children).join(" ");
      for (let e = 0; e < this.configs.length; e++) {
        const n = this.configs[e];
        t = s(
          t,
          n.key,
          `<span style="color: ${n.color}">[(key)]</span>`,
          {
            ignorePattern: c,
            replaceAll: !0,
            openCaseMode: this.openCaseMode
          }
        );
      }
      return t;
    }
  }
}, h = ["innerHTML"];
function g(t, e, n, f, d, r) {
  return a(), i("span", {
    class: "r-highlight-text",
    innerHTML: r.textarr
  }, null, 8, h);
}
const o = /* @__PURE__ */ l(p, [["render", g], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/highlight-text/highlight-text.vue"]]);
o.install = function(t) {
  t.component(o.name, o);
};
export {
  o as default
};
